import { Mark } from '@tiptap/core'

/**
 * VocalClass extension for TipTap
 * Allows applying vocal classes (vocal1-vocal10) to selected text
 * These classes are styled via CSS in index.css
 */
export const VocalClass = Mark.create({
    name: 'vocalClass',
    priority: 100, // Lower priority so it renders inside section marks
    addOptions() {
        return {
            types: ['textStyle'],
        }
    },
    addAttributes() {
        return {
            class: {
                default: null,
                parseHTML: element => {
                    // Check if element has a vocal class
                    const vocalClasses = ['vocal1', 'vocal2', 'vocal3', 'vocal4', 'vocal5', 
                                         'vocal6', 'vocal7', 'vocal8', 'vocal9', 'vocal10']
                    for (const vocalClass of vocalClasses) {
                        if (element.classList.contains(vocalClass)) {
                            return vocalClass
                        }
                    }
                    return null
                },
                renderHTML: attributes => {
                    if (!attributes.class) {
                        return {}
                    }
                    return {
                        class: attributes.class,
                    }
                },
            },
        }
    },
    parseHTML() {
        return [
            {
                tag: 'span.vocal1, span.vocal2, span.vocal3, span.vocal4, span.vocal5, span.vocal6, span.vocal7, span.vocal8, span.vocal9, span.vocal10',
                getAttrs: element => {
                    const vocalClasses = ['vocal1', 'vocal2', 'vocal3', 'vocal4', 'vocal5', 
                                         'vocal6', 'vocal7', 'vocal8', 'vocal9', 'vocal10']
                    for (const vocalClass of vocalClasses) {
                        if (element.classList.contains(vocalClass)) {
                            return { class: vocalClass }
                        }
                    }
                    return null
                },
            },
        ]
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', HTMLAttributes, 0]
    },
    addCommands() {
        return {
            setVocalClass: (vocalClass) => ({ chain }) => {
                // Marks are automatically preserved in ProseMirror, so section marks
                // will be maintained when applying vocal marks
                // The priority setting ensures section marks wrap vocal marks in HTML output
                return chain()
                    .setMark(this.name, { class: vocalClass })
                    .run()
            },
            unsetVocalClass: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name)
                    .run()
            },
        }
    },
})

